"use client";
import { useTheme } from "next-themes";

export default function ToggleTheme() {
  const { theme, setTheme } = useTheme();
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        className="sr-only peer"
        name="Toggle Theme"
        type="checkbox"
        checked={theme == "dark"}
        onChange={() => setTheme(theme == "dark" ? "light" : "dark")}
      />
      <div className="w-[58px] h-[28px] rounded-full ring-0 peer duration-500 outline-none bg-[#ffffff7a] overflow-hidden before:flex before:items-center before:justify-center after:flex after:items-center after:justify-center before:content-sun before:absolute before:h-6 before:w-6 before:top-1/2 before:bg-[#fffa] before:rounded-full before:left-1 before:-translate-y-1/2 before:transition-all before:duration-700 peer-checked:before:opacity-0 peer-checked:before:-translate-y-full peer-checked:bg-[#64646433] after:content-moon after:absolute after:bg-[#1d1d1d] after:rounded-full after:top-[2px] after:right-0.5 after:translate-y-full after:w-6 after:h-6 after:opacity-0 after:transition-all after:duration-700 peer-checked:after:opacity-100 peer-checked:after:translate-y-0" />
    </label>
  );
}
